var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholderImage el-image",style:({ paddingBottom: ((_vm.height / _vm.width * 100) + "%")})},[_c('img',{staticClass:"el-image__inner",attrs:{"src":_vm.src,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }